import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../material-ui/Button';
import { useStyles } from './useStyles';

const buttonLabels = ['loginPage.loginButton', 'send'];

export const SendButton = memo(({ onClick, step = 0, disabled }) => {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <Button variant="contained" onClick={onClick} className={classes.button} disabled={disabled}>
            {translate(buttonLabels[step])}
        </Button>
    );
});
